<template>
  <svg
    class="lp-icon"
    :viewBox="def.viewBox"
    :width="size"
    :height="size"
    fill="none"
    :stroke="color"
    :stroke-width="def.strokeWidth ?? 1.25"
    stroke-linecap="round"
    stroke-linejoin="round"
    :filter="def.filter"
    aria-hidden="true"
    v-html="def.content"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ICON_REGISTRY, type IconName } from './icon-paths';

const props = withDefaults(
  defineProps<{
    name: IconName;
    size?: number;
    color?: string;
  }>(),
  {
    size: 24,
    color: 'currentColor',
  }
);

const def = computed(() => ICON_REGISTRY[props.name]);
</script>

<style>
.lp-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
